export default __webpack_public_path__ + "static/media/ic_video_primary.26594f96.svg";